import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import {  FrontendSettings } from "../common/models";

import defaultConfigData from './defaultConfiguration';

const ConfigContext = createContext<FrontendSettings | null>(null);

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider = ({ children }: ConfigProviderProps) => {
  const [config, setConfig] = useState<FrontendSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (import.meta.env.MODE === 'development') {
        setConfig(defaultConfigData);
        setLoading(false);
    } else {
      fetch("/api/config")
      .then((res) => res.json())
      .then((configData) => {
        setConfig(configData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading config:", error);
        console.warn("Falling back to default configuration");
        setConfig(defaultConfigData);
        setLoading(false);
      });
    }
  }, []);

  if (loading) {
    return <div>Loading configuration...</div>;
  }

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

 
export const useConfig = () => {
  const cfgCtx = useContext(ConfigContext);

  if (cfgCtx === null) {
    throw new Error("ConfigContext is null - that should not be the case!");
  }
  return cfgCtx;
};